import React from 'react';
import { Shield, Target, Award, Users } from 'lucide-react';
export function ValuePillars() {
  const pillars = [{
    title: 'Discipline & Confidence',
    description: 'Develop mental focus, self-control, and personal confidence through structured martial arts practice that challenges you to grow beyond your perceived limits.',
    icon: Shield
  }, {
    title: 'Structured Training Environment',
    description: 'Train within a clear curriculum with consistent standards and guided progression. Every class builds on the last, ensuring steady development and measurable growth.',
    icon: Target
  }, {
    title: 'Experienced Instruction',
    description: 'Learn from professional instructors dedicated to proper technique, student safety, and individual development. Quality instruction makes the difference.',
    icon: Award
  }, {
    title: 'Family-Friendly & Multi-Location',
    description: 'Access convenient training locations across Michigan, each maintaining the same high standards and welcoming environment for students of all ages.',
    icon: Users
  }];
  return <section className="py-20 bg-white" data-id="element-384">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-385">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-386">
          {pillars.map((pillar, index) => <div key={index} className="flex flex-col items-center text-center p-6 rounded-xl bg-slate-50 border border-slate-100" data-id="element-387">
              <div className="h-12 w-12 bg-[#1a2332] rounded-lg flex items-center justify-center mb-6 text-white" data-id="element-388">
                <pillar.icon className="h-6 w-6" data-id="element-389" />
              </div>
              <h3 className="text-lg font-bold text-[#1a2332] mb-3" data-id="element-390">
                {pillar.title}
              </h3>
              <p className="text-slate-600 leading-relaxed text-sm" data-id="element-391">
                {pillar.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}